export default __webpack_public_path__ + "static/media/step-3-inactive.76d8d5a4.svg";